import {
  PLACEHOLDER_REGEX,
  TextEditorPlaceholders,
} from '@components/inputs/RichTextEditor/TextEditorUtil'
import { GetMembershipDetailsOutput } from '@graphql/__generated/graphql'
import { EventCreation } from '@libs/CreateEventContext'
import moment from 'moment'
import { getEventDateTime } from '@libs/EventTime'

const domain = process.env.NEXT_PUBLIC_DOMAIN as string
const PLATFORM_URL = `${domain.includes('qa') || domain.includes('app') ? 'https://' : 'http://'}${domain}/event/`
// console.log({ PLATFORM_URL, domain })

const getEmailStyle = () =>
  `
    <style>
        img {
            border: none;
            -ms-interpolation-mode: bicubic;
            max-width: 100%;
        }
        .img-logo {
          max-width: 150px;
          min-width: 70px;

          max-height: 150px;
          min-height: 70px;

          height: 35%;
          width: auto;
          border-radius: 6px;
        }
        .logo-landscape {
          min-height: 50px !important;
          max-width: 175px !important;
          margin: 10px !important;
        }

        body {
            background-color: #f6f6f6;
            font-family: sans-serif;
            -webkit-font-smoothing: antialiased;
            font-size: 14px;
            line-height: 1.4;
            margin: 0;
            padding: 0;
            -ms-text-size-adjust: 100%;
            -webkit-text-size-adjust: 100%;
        }

        table {
            border-collapse: separate;
            width: 100%;
        }

        table td {
            font-family: sans-serif;
            font-size: 14px;
            vertical-align: top;
        }

        .body {
            background-color: #f6f6f6;
            width: 100%;
        }

        .container {
            display: block;
            margin: 0 auto !important;
            max-width: 580px;
            padding: 10px;
            width: 580px;
        }

        .content {
            box-sizing: border-box;
            display: block;
            margin: 0 auto;
            max-width: 580px;
            padding: 10px;
        }

        .main {
            background: #ffffff;
            border-radius: 3px;
            width: 100%;
        }

        .wrapper {
            box-sizing: border-box;
            padding: 20px;
        }

        .content-block {
            padding-bottom: 10px;
            padding-top: 10px;
        }

        .footer {
            clear: both;
            margin-top: 10px;
            text-align: center;
            width: 100%;
        }

        .footer td,
        .footer p,
        .footer span,
        .footer a {
            color: #999999;
            font-size: 12px;
            text-align: center;
        }

        h1,
        h2,
        h3,
        h4 {
            color: #000000;
            font-family: sans-serif;
            font-weight: 400;
            line-height: 1.4;
            margin: 0;
            margin-bottom: 30px;
        }

        h1 {
            font-size: 35px;
            font-weight: 300;
            text-align: center;
            text-transform: capitalize;
        }

        p,
        ul,
        ol {
            font-family: sans-serif;
            font-size: 14px;
            font-weight: normal;
            margin: 0;
            margin-bottom: 15px;
        }

        p li,
        ul li,
        ol li {
            list-style-position: inside;
            margin-left: 5px;
        }
                  
        ol.gap-1 li {
          margin-bottom: 6px;
        }

        ol li p {
          display: inline;
        }

        a {
            color: #3498db;
            text-decoration: underline;
        }

        .btn {
            box-sizing: border-box;
            width: 100%;
        }

        .btn>tbody>tr>td {
            padding-bottom: 15px;
        }

        .btn table {
            width: auto;
        }

        .btn table td {
            background-color: #ffffff;
            border-radius: 5px;
            text-align: center;
        }

        .btn a {
            background-color: #ffffff;
            border: solid 1px #3498db;
            border-radius: 5px;
            box-sizing: border-box;
            color: #3498db;
            cursor: pointer;
            display: inline-block;
            font-size: 14px;
            font-weight: bold;
            margin: 0;
            padding: 12px 25px;
            text-decoration: none;
            text-transform: capitalize;
        }

        .btn-primary table td {
            background-color: #3498db;
        }

        .btn-primary a {
            background-color: #3498db;
            border-color: #3498db;
            color: #ffffff;
        }

        .last {
            margin-bottom: 0;
        }

        .first {
            margin-top: 0;
        }

        .align-center {
            text-align: center;
        }

        .align-right {
            text-align: right;
        }

        .align-left {
            text-align: left;
        }

        .clear {
            clear: both;
        }

        .mt0 {
            margin-top: 0;
        }

        .mb0 {
            margin-bottom: 0;
        }

        .preheader {
            color: transparent;
            display: none;
            height: 0;
            max-height: 0;
            max-width: 0;
            opacity: 0;
            overflow: hidden;
            visibility: hidden;
            width: 0;
        }

        .powered-by a {
            text-decoration: none;
        }

        hr {
            border: 0;
            border-bottom: 1px solid #f6f6f6;
            margin: 20px 0;
        }

        @media only screen and (max-width: 620px) {
            table.body h1 {
                font-size: 28px !important;
                margin-bottom: 10px !important;
            }

            table.body p,
            table.body ul,
            table.body ol,
            table.body td,
            table.body span,
            table.body a {
                font-size: 16px !important;
            }

            table.body .wrapper,
            table.body .article {
                padding: 10px !important;
            }

            table.body .content {
                padding: 0 !important;
            }

            table.body .container {
                padding: 0 !important;
                width: 100% !important;
            }

            table.body .btn table {
                width: 100% !important;
            }

            table.body .btn a {
                width: 100% !important;
            }

            table.body .img-responsive {
                height: auto !important;
                max-width: 100% !important;
                width: auto !important;
            }
        }

        @media all {
            .ExternalClass {
                width: 100%;
            }

            .ExternalClass,
            .ExternalClass p,
            .ExternalClass span,
            .ExternalClass font,
            .ExternalClass td,
            .ExternalClass div {
                line-height: 100%;
            }

            .apple-link a {
                color: inherit !important;
                font-family: inherit !important;
                font-size: inherit !important;
                font-weight: inherit !important;
                line-height: inherit !important;
                margin: 0 !important;
                text-decoration: none !important;
            }

            .btn-primary table td:hover {
                background-color: #34495e !important;
            }

            .btn-primary a:hover {
                background-color: #34495e !important;
                border-color: #34495e !important;
            }
        }
    </style>
`

const getLogoImage = (imgURL?: string) =>
  `<a href="#"><img src="${imgURL ?? 'https://static.wixstatic.com/media/7fc37b_02f9a20bf6e346fc9461ce658699b7d9~mv2.png/v1/crop/x_126,y_104,w_513,h_563/fill/w_78,h_85,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Forumm%20Logo%20Transparent.png'}" alt="forumm-logo" class="img-logo" /></a>`

const getEmailHead = (title?: string) =>
  `
    <!doctype html>
    <html>
        <head>
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
            <title>${title ?? 'Confirmed Booking'}</title>
            ${getEmailStyle()}
        </head>
`

const getEmailBodyWrapper = (content: string, logoUrl?: string) => {
  return `
    <body>
    <span class="preheader">Email Preview</span>
    <table role="presentation" border="0" cellpadding="0" cellspacing="0" class="body">
        <tr>
            <td>&nbsp;</td>
            <td class="container">
                <div class="content">
                    <table role="presentation" class="main">
                        <tr>
                            <td class="wrapper">
                                <table role="presentation" border="0" cellpadding="0" cellspacing="0">
                                    <tr>
                                        <td class="align-center">
                                          ${getLogoImage(logoUrl)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            ${content}
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>
                    <div class="footer">
                        <table role="presentation" border="0" cellpadding="0" cellspacing="0">
                            <tr>
                                <td class="content-block">
                                    <span class="apple-link">Forumm</span>
                                    <br> Want to explore more? Visit us at <a href="https://www.forumm.to/">forumm.to</a>.
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </td>
            <td>&nbsp;</td>
        </tr>
    </table>
    </body>
    </html>
`
}

// const PLACEHOLDER_REGEX = /{\{\s*[\w]+\s*}}/g

const findWithRegex = (regex: RegExp, content: any) => {
  return regex.exec(content)
}

const prepContent = (
  content: string,
  data?: Partial<EventCreation | GetMembershipDetailsOutput>,
  type: 'event' | 'membership' = 'event'
): string => {
  let payload = content
  let hasMore = false
  const event = type === 'event' ? (data as Partial<EventCreation>) : undefined
  const match = findWithRegex(PLACEHOLDER_REGEX(type), payload)

  if (match !== null && typeof match?.[0] === 'string') {
    let parsedData: any[][] = []
    if (type === 'event') {
      parsedData = [
        ...Object.entries(event?.event ?? {}),
        [
          'eventlink',
          `<a href="${PLATFORM_URL}${event?.eventId}">Event Page</a>`,
        ],
      ]
    }
    if (type === 'membership') {
      const membership = data as Partial<GetMembershipDetailsOutput>
      parsedData = [...Object.entries(membership ?? {})]
    }
    // console.log({
    //   type,
    //   match: match?.[0],
    //   firstname: match?.[0].toLowerCase().includes('firstname'),
    //   lastname: match?.[0].toLowerCase().includes('lastname'),
    //   starttime: match?.[0].toLowerCase().includes('starttime'),
    //   title: match?.[0].toLowerCase().includes('title'),
    //   qr: match?.[0].toLowerCase().includes('qr'),
    // })

    TextEditorPlaceholders.forEach((p) => {
      const val = p.value.trim() // {{firstname}}
      const key = val.slice(2, -2) // firstname

      if (payload.toLowerCase().includes(val)) {
        let data
        if (p.useRealDataIfAvailable) {
          data = parsedData.find(
            (f) => f[0].toLowerCase() === key.toLowerCase()
          )?.[1] as string
        } else data = p.dummyData

        if (moment(data, moment.ISO_8601, true).isValid()) {
          data = event
            ? getEventDateTime(data, event.event).toFormat(
                'd LLL yyyy, HH:mm ZZZZ'
              )
            : moment(data).format('D MMMM YYYY, h:mm A')
        }

        payload = payload.replaceAll(val, data ?? 'Unsupported Data')
      }
    })
  }
  // PLACEHOLDER_REGEX.lastIndex = 0
  hasMore = findWithRegex(PLACEHOLDER_REGEX(type), payload) !== null
  // console.log({
  //   match,
  //   hasMore,
  //   cond: match !== null && typeof match?.[0] === 'string',
  //   payload,
  // })
  if (hasMore) return prepContent(payload, data)

  return payload
}

export const getEmailPreviewContent = (
  content: string,
  title: string,
  logoUrl?: string,
  data?: Partial<EventCreation | GetMembershipDetailsOutput>,
  type: 'event' | 'membership' = 'event'
): string => {
  const preppedContent = prepContent(content, data, type)
  const email = getEmailHead().concat(
    getEmailBodyWrapper(preppedContent, logoUrl)
  )
  return email
}
